export default `/* Ids Media Gallery Component */
:host {
  display: block;
  aspect-ratio: 1/1;
  height: auto;
  width: 100%;
  max-height: var(--ids-media-viewer-max-height);
  min-height: var(--ids-media-viewer-min-height);
  margin-block-end: var(--ids-space-sm);
  cursor: zoom-in;
}

.ids-media-viewer-zoom-container {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid var(--ids-color-border-weaker);
}

.ids-media-viewer-zoom-result {
  display: none;
  border: 1px solid #d4d4d4;
  width: 300px;
  height: 300px;
}

.ids-hover-zoom-container {
  aspect-ratio: 1/1;
  position: absolute;
  left: 100%;
  top: 0;
  width: 40vw;
  height: auto;
  overflow: hidden;
  border: 1px solid var(--ids-color-border-weaker);
  box-shadow: var(--ids-shadow-10);
  z-index: var(--ids-media-viewer-hover-z-index);
}
@media screen and (max-width: 767px) {
  .ids-hover-zoom-container {
    display: none;
  }
}
:host([dir=rtl]) .ids-hover-zoom-container {
  left: auto;
  right: 100%;
}

.ids-media-viewer-video {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

ids-image {
  --ids-image-object-fit: cover;
  aspect-ratio: 1/1;
  object-fit: contain;
  position: absolute;
  will-change: transform;
  user-select: none;
  cursor: zoom-in;
}
ids-image[hidden] {
  display: none;
}

:host([object-fit=contain]) ids-image {
  --ids-image-object-fit: contain;
}

:host([object-fit=cover]) ids-image {
  --ids-image-object-fit: cover;
}

:host([object-fit=fill]) ids-image {
  --ids-image-object-fit: fill;
}

:host([object-fit=none]) ids-image {
  --ids-image-object-fit: none;
}

:host([object-fit=scale-down]) ids-image {
  --ids-image-object-fit: scale-down;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
